import React from "react";

interface InfoCardProps {
  image: React.ReactNode;
  title: string;
  description: string;
  className?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({
  image,
  title,
  description,
  className,
}) => {
  return (
    <div
      className={`flex flex-col items-center  rounded-xl bg-[#EEF4FF] p-6 text-center ${className}`}
    >
      <div className="mb-4">{image}</div>
      <h3 className="font-playfair font-semibold text-lg text-[#1A2530] mb-2">
        {title}
      </h3>
      <p className="font-roboto text-sm text-[#6B7280]">{description}</p>
    </div>
  );
};

export default InfoCard;
